import { useEffect, useRef } from "react"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const partners = [
  "TSMC",
  "GlobalFoundries",
  "Samsung",
  "Intel",
  "Synopsys",
  "Cadence",
  "Ansys",
  "Siemens",
]

function buildTrackItems(items: string[]) {
  return Array.from({ length: 2 }, () => items).flat()
}

export function PartnersSection() {
  const sectionRef = useRef<HTMLElement>(null)
  const headerRef = useRef<HTMLParagraphElement>(null)
  const marqueeRef = useRef<HTMLDivElement>(null)

  const trackItems = buildTrackItems(partners)

  useEffect(() => {
    if (!sectionRef.current || !headerRef.current || !marqueeRef.current) return

    const ctx = gsap.context(() => {
      gsap.from(headerRef.current, {
        y: 24,
        opacity: 0,
        duration: 0.9,
        ease: "power3.out",
        scrollTrigger: {
          trigger: headerRef.current,
          start: "top 88%",
          toggleActions: "play none none reverse",
        },
      })

      gsap.from(marqueeRef.current, {
        y: 32,
        opacity: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: marqueeRef.current,
          start: "top 90%",
          toggleActions: "play none none reverse",
        },
      })
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={sectionRef}
      id="partners"
      className="relative border-t border-border/30 py-24 md:py-32"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-12">
        <p
          ref={headerRef}
          className="text-center font-mono text-[10px] uppercase tracking-[0.35em] text-muted-foreground md:text-xs md:tracking-[0.4em]"
        >
          Proven across the industry&apos;s leading foundries, nodes &amp; tools
        </p>
      </div>

      <div ref={marqueeRef} className="mt-12 overflow-hidden border-y border-border/30 py-7 md:py-9">
        <div className="partners-marquee flex w-max" style={{ animationDuration: "40s" }}>
          {[0, 1].map((copy) => (
            <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
              {trackItems.map((name, index) => (
                <span
                  key={`${copy}-${name}-${index}`}
                  className="flex shrink-0 items-center px-10 font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground md:px-16 md:text-xs md:tracking-[0.3em]"
                >
                  {name}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
